/* ==========================================================================
   THE FORGE — theme runtime
   Vanilla, no framework, progressive enhancement throughout: without this file
   the store still browses, adds to cart and checks out through native forms.
   ========================================================================== */
(function () {
  'use strict';

  document.documentElement.classList.add('js');

  var T = window.ForgeTheme || {};
  var routes = T.routes || {};
  var strings = T.strings || {};
  /* Shopify's t filter HTML-escapes translations (didn't becomes didn&#39;t); these
     are written with textContent, so decode the entities once up front. */
  (function () {
    var d = document.createElement('textarea');
    Object.keys(strings).forEach(function (k) { d.innerHTML = strings[k] || ''; strings[k] = d.value; });
  })();
  var money = function (cents) {
    var v = (cents / 100).toFixed(2);
    var f = T.moneyFormat || '{{amount}}';
    return f.replace(/\{\{\s*amount\s*\}\}/, v)
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
            .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','));
  };

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Toast ------------------------------------------------------ */
  var toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.setAttribute('data-show', 'true');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.setAttribute('data-show', 'false'); }, 3200);
  }
  T.toast = toast;

  /* ---------- Focus trap ------------------------------------------------- */
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  function trap(container, e) {
    var items = $$(FOCUSABLE, container).filter(function (el) { return el.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- Scroll lock ------------------------------------------------ */
  var lockCount = 0, savedY = 0, locked = false;
  function lock() {
    if (lockCount++) return;
    savedY = window.scrollY;
    locked = true;
    document.body.style.position = 'fixed';
    document.body.style.top = -savedY + 'px';
    document.body.style.width = '100%';
  }
  function unlock() {
    // Only restore when a lock is really active, or an unbalanced call jumps
    // the page to the top on an ordinary click.
    if (!locked) { lockCount = 0; return; }
    if (--lockCount > 0) return;
    lockCount = 0;
    locked = false;
    // Smooth scrolling would animate this restore against a collapsed page.
    var root = document.documentElement;
    var prev = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, savedY);
    root.style.scrollBehavior = prev;
  }

  /* ---------- Global nav (mobile) ----------------------------------------- */
  function header() {
    var burger = $('[data-burger]');
    var nav = $('[data-nav]');
    if (!burger || !nav) return;

    var setNav = function (open) {
      burger.setAttribute('aria-expanded', String(open));
      nav.setAttribute('data-open', String(open));
      open ? lock() : unlock();
    };
    burger.addEventListener('click', function () {
      setNav(burger.getAttribute('aria-expanded') !== 'true');
    });
    nav.addEventListener('keydown', function (e) {
      if (e.key === 'Tab' && nav.getAttribute('data-open') === 'true') trap(nav, e);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && burger.getAttribute('aria-expanded') === 'true') {
        setNav(false); burger.focus();
      }
    });
    var mq = window.matchMedia('(min-width: 900px)');
    var onMq = function () { if (mq.matches && burger.getAttribute('aria-expanded') === 'true') setNav(false); };
    mq.addEventListener ? mq.addEventListener('change', onMq) : mq.addListener(onMq);
  }

  /* ---------- Rails: paddles that page by one card ----------------------- */
  function rails(scope) {
    $$('[data-rail]', scope).forEach(function (rail) {
      if (rail.__bound) return;
      rail.__bound = true;
      var track = $('[data-rail-track]', rail);
      var prev = $('[data-rail-prev]', rail);
      var next = $('[data-rail-next]', rail);
      if (!track || !prev || !next) return;

      function step() {
        var card = track.firstElementChild;
        if (!card) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }
      function sync() {
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
        rail.toggleAttribute('data-static', max <= 0);
      }
      function go(dir) {
        track.scrollBy({ left: dir * step(), behavior: reduced.matches ? 'auto' : 'smooth' });
      }
      prev.addEventListener('click', function () { go(-1); });
      next.addEventListener('click', function () { go(1); });
      // Two property reads per scroll event — cheap enough to run directly,
      // and it cannot stall when requestAnimationFrame is paused.
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync, { passive: true });
      sync();
    });
  }

  /* ---------- Cart ------------------------------------------------------- */
  var TICK = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  var Cart = {
    drawer: null,
    lastFocus: null,

    open: function () {
      this.drawer = this.drawer || $('[data-cart-drawer]');
      if (!this.drawer || this.drawer.getAttribute('data-open') === 'true') return;
      this.lastFocus = document.activeElement;
      this.drawer.setAttribute('data-open', 'true');
      this.drawer.setAttribute('aria-hidden', 'false');
      lock();
      var f = $(FOCUSABLE, this.drawer);
      if (f) f.focus();
    },

    close: function () {
      if (!this.drawer || this.drawer.getAttribute('data-open') !== 'true') return;
      this.drawer.setAttribute('data-open', 'false');
      this.drawer.setAttribute('aria-hidden', 'true');
      unlock();
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    },

    // Fresh markup from Shopify's Section Rendering API — Liquid stays the
    // single source of truth for what the cart looks like.
    refresh: function () {
      var ids = ['cart-drawer', 'cart-count'];
      var main = $('[data-cart-main]');
      if (main) ids.push(main.getAttribute('data-cart-main'));
      return fetch(routes.root + '?sections=' + ids.join(','), { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          Object.keys(data).forEach(function (id) {
            var target = $('[data-section-id="' + id + '"]');
            if (!target) return;
            var doc = new DOMParser().parseFromString(data[id], 'text/html');
            var fresh = doc.querySelector('[data-section-id="' + id + '"]');
            if (!fresh) return;
            var open = target.getAttribute('data-open');
            target.innerHTML = fresh.innerHTML;
            if (open) target.setAttribute('data-open', open);
          });
        })
        .catch(function () { /* the cart page still works */ });
    },

    add: function (form, btn) {
      var body = new FormData(form);
      var iconOnly = !!(btn && btn.hasAttribute('data-icon-btn'));
      var original = btn ? btn.innerHTML : '';
      var added = false;
      if (btn) {
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('is-busy');
        if (!iconOnly) btn.textContent = strings.adding || 'Adding…';
      }

      return fetch(routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: body
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok) {
            toast(res.json.description || res.json.message || strings.error || 'Could not add that.');
            return;
          }
          added = true;
          return Cart.refresh().then(function () {
            toast(strings.added || 'Added to cart');
            Cart.open();
          });
        })
        .catch(function () { toast(strings.error || 'Something went wrong.'); })
        .then(function () {
          if (!btn) return;
          btn.classList.remove('is-busy');
          if (!added) { btn.removeAttribute('aria-disabled'); btn.innerHTML = original; return; }
          // Confirm on the button itself: a tick (and "Added") for a moment, then back.
          btn.classList.add('is-added');
          btn.innerHTML = TICK + (iconOnly ? '' : '<span>' + (strings.added_short || 'Added') + '</span>');
          setTimeout(function () {
            btn.classList.remove('is-added');
            btn.innerHTML = original;
            btn.removeAttribute('aria-disabled');
          }, 1500);
        });
    },

    change: function (line, quantity) {
      return fetch(routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function () { return Cart.refresh(); })
        .catch(function () { window.location.href = routes.cart_url; });
    }
  };
  T.Cart = Cart;

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-cart-open]');
    if (openBtn) { e.preventDefault(); Cart.open(); return; }

    var closeBtn = e.target.closest('[data-cart-close]');
    if (closeBtn) { e.preventDefault(); Cart.close(); return; }

    var rm = e.target.closest('[data-line-remove]');
    if (rm) { e.preventDefault(); Cart.change(rm.getAttribute('data-line-remove'), 0); return; }

    var stepBtn = e.target.closest('[data-line-step]');
    if (stepBtn) {
      e.preventDefault();
      Cart.change(stepBtn.getAttribute('data-line'), parseInt(stepBtn.getAttribute('data-next'), 10));
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-cart-form]');
    if (!form) return;
    e.preventDefault();
    Cart.add(form, form.querySelector('[data-add-btn]'));
  });

  document.addEventListener('keydown', function (e) {
    var d = $('[data-cart-drawer]');
    if (!d || d.getAttribute('data-open') !== 'true') return;
    if (e.key === 'Escape') Cart.close();
    if (e.key === 'Tab') trap(d, e);
  });

  /* ---------- Quantity steppers ------------------------------------------ */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentNode.querySelector('input');
    if (!input) return;
    var min = parseInt(input.min || '1', 10);
    input.value = Math.max(min, parseInt(input.value || min, 10) + parseInt(b.getAttribute('data-qty'), 10));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product variants ------------------------------------------- */
  // Matched against the variant JSON Shopify prints, never rebuilt from titles.
  function variants(root) {
    var dataEl = $('[data-variant-json]', root);
    if (!dataEl) return;
    var list;
    try { list = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var idInput = $('[data-variant-id]', root);
    var priceEl = $('[data-price]', root);
    var stockEl = $('[data-stock]', root);
    var addBtn = $('[data-add-btn]', root);
    var skuEl = $('[data-sku]', root);
    var barPrice = $('[data-buybar-price]');
    var barBtn = $('[data-buybar-jump]');
    var chosenEls = $$('[data-opt-chosen]', root);

    function selected() {
      return $$('[data-opt]', root).map(function (group) {
        var checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function find(opts) {
      for (var i = 0; i < list.length; i++) {
        var v = list[i], match = true;
        for (var j = 0; j < opts.length; j++) {
          if (opts[j] !== null && v.options[j] !== opts[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function markAvailability(opts) {
      $$('[data-opt]', root).forEach(function (group, gi) {
        $$('input', group).forEach(function (input) {
          var probe = opts.slice();
          probe[gi] = input.value;
          var exists = !!find(probe);
          input.closest('.opts__item').classList.toggle('is-gone', !exists);
          input.disabled = !exists;
        });
      });
    }

    function update() {
      var opts = selected();
      var v = find(opts);
      markAvailability(opts);
      chosenEls.forEach(function (el, i) { el.textContent = opts[i] || ''; });

      if (!v) {
        if (addBtn) { addBtn.setAttribute('aria-disabled', 'true'); addBtn.textContent = strings.unavailable || 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (skuEl) skuEl.textContent = v.sku || '';

      if (priceEl) {
        var html = '<span class="price__now">' + money(v.price) + '</span>';
        if (v.compare_at_price && v.compare_at_price > v.price) {
          html += '<s class="price__was">' + money(v.compare_at_price) + '</s>';
          // The saving is worth stating outright, and it changes with the variant.
          var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
          if (pct > 0) {
            var label = (strings.percent_off || '__PCT__% off').replace('__PCT__', pct);
            html += '<span class="tag tag--sale tag--inline">' + label + '</span>';
          }
          priceEl.classList.add('price--on-sale');
        } else {
          priceEl.classList.remove('price--on-sale');
        }
        var note = priceEl.getAttribute('data-price-note');
        if (note) html += '<span class="price__note">' + note + '</span>';
        priceEl.innerHTML = html;
      }
      if (barPrice) barPrice.textContent = money(v.price);

      if (stockEl) {
        stockEl.setAttribute('data-state', v.available ? 'in' : 'out');
        var t = $('[data-stock-text]', stockEl);
        if (t) t.textContent = v.available ? (strings.in_stock || 'In stock') : (strings.sold_out || 'Sold out');
      }
      [addBtn, barBtn].forEach(function (b) {
        if (!b) return;
        if (b === barBtn) b.classList.toggle('is-soldout', !v.available);
        if (v.available) { b.removeAttribute('aria-disabled'); b.textContent = strings.add_to_cart || 'Add to cart'; }
        else { b.setAttribute('aria-disabled', b === barBtn ? 'false' : 'true'); b.textContent = strings.sold_out || 'Sold out'; }
      });

      if (v.featured_media_id) {
        var thumb = $('[data-media-id="' + v.featured_media_id + '"]', root);
        if (thumb) thumb.click();
      }

      if (history.replaceState && root.hasAttribute('data-update-url')) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u.toString());
      }
    }

    $$('[data-opt] input', root).forEach(function (i) { i.addEventListener('change', update); });
    update();
  }

  /* ---------- Product gallery -------------------------------------------- */
  function gallery(root) {
    var main = $('[data-gallery-main]', root);
    if (!main) return;
    $$('[data-media-id]', root).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full');
        var alt = thumb.getAttribute('data-alt') || '';
        var frame = main.querySelector('.frame') || main;
        if (src) frame.innerHTML = '<img src="' + src + '" alt="' + alt.replace(/"/g, '&quot;') + '" width="1400" height="1400">';
        $$('[data-media-id]', root).forEach(function (t) { t.setAttribute('aria-current', String(t === thumb)); });
      });
    });
  }

  /* ---------- Sticky product bar ----------------------------------------- */
  function buybar() {
    var bar = $('[data-buybar]');
    var anchor = $('[data-buybar-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      // Show only once the buy controls have scrolled up and out of view.
      var e = entries[0];
      bar.setAttribute('data-show', String(!e.isIntersecting && e.boundingClientRect.top < 0));
    }, { rootMargin: '-48px 0px 0px 0px' }).observe(anchor);

    var jump = $('[data-buybar-jump]', bar);
    if (jump) jump.addEventListener('click', function () {
      var add = $('[data-add-btn]');
      if (add && add.getAttribute('aria-disabled') !== 'true') {
        add.closest('form').requestSubmit ? add.closest('form').requestSubmit() : add.click();
      } else {
        anchor.scrollIntoView({ behavior: reduced.matches ? 'auto' : 'smooth', block: 'center' });
      }
    });
  }

  /* ---------- Landing on a fragment --------------------------------------- */
  // A link from another page arrives with a hash. The browser starts that
  // scroll while the document is still growing, and a smooth scroll against a
  // moving page gives up at the top, so the landing is done again here once
  // layout has settled. If the reader has already scrolled, leave them alone.
  function fragment() {
    var id = location.hash.slice(1);
    if (!id) return;
    var target = null;
    try { target = document.getElementById(decodeURIComponent(id)); } catch (e) { return; }
    if (!target) return;

    var moved = false;
    var mark = function () { moved = true; };
    ['wheel', 'touchstart', 'keydown'].forEach(function (ev) {
      window.addEventListener(ev, mark, { once: true, passive: true });
    });

    var root = document.documentElement;
    function land() {
      var prev = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      target.scrollIntoView();
      root.style.scrollBehavior = prev;
    }

    land();
    window.addEventListener('load', function () {
      if (!moved) requestAnimationFrame(land);
    }, { once: true });
  }

  /* ---------- Boot -------------------------------------------------------- */
  function boot(scope) {
    scope = scope || document;
    $$('[data-product-form]', scope).forEach(function (root) { gallery(root); variants(root); });
    rails(scope);
  }

  function init() {
    header();
    boot();
    buybar();
    fragment();
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); buybar(); });

  window.ForgeTheme = T;
})();
